import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from './shared/Services/authentication.service';
import {ExactLogService} from './back-office/Services/exact-log.service';
import {ServiceRequestService } from './back-office/Services/service-request.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'UrbanSofa Portal';
  options: any = {
    position: ['top', 'right'],
    timeOut: 5000
  };

  constructor(
    private router: Router,
    private translate: TranslateService,
    private auth: AuthenticationService,
    private exactLogService: ExactLogService,
    private serviceRequestService: ServiceRequestService
  ) {
    new Promise((resolve, reject) => {
      translate.setDefaultLang('en');
      resolve(true);
    }).then(() => {
      translate.use(this.auth.getLocale());
    });
    router.events.subscribe(event => {
      if (event instanceof NavigationStart && this.auth.isBackOffice()) {
        // TODO: Uncomment this if you want enable service request feature
        this.serviceRequestService.fetchNotificationsCount();
        this.exactLogService.getCrmUpdateNotificationsCount();
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
